import { render, staticRenderFns } from "./AlteredInternet.vue?vue&type=template&id=dbc146d8&"
import script from "./AlteredInternet.vue?vue&type=script&lang=js&"
export * from "./AlteredInternet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports